import {Directive, Host, Input, OnDestroy, OnInit, SkipSelf} from '@angular/core';
import {AbstractControl, ControlContainer} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {Subscription} from 'rxjs';
import {FormValidationService} from './form-validation.service';
import {TranslateService} from '@ngx-translate/core';

@Directive({
  selector: '[utilsValidationMessage]'
})
export class ValidationMessageDirective implements OnInit, OnDestroy {

  /**
   * Falls die Direktive zusammen mit [formControlName] UND [datevMessagePath] verwendet wird,
   * so kann die Übergabe der ID entfallen.
   */
  @Input()
  public utilsValidationMessage: string;
  @Input()
  public datevMessagePath: string;
  @Input()
  public formControlName: string;
  private statusChangesSubscription: Subscription;
  private validateFormSubscription: Subscription;
  private control: AbstractControl;

  constructor(private readonly messageService: DatevMessageService,
              private readonly formValidationService: FormValidationService,
              @Host() @SkipSelf() private readonly controlContainer: ControlContainer,
              private readonly translateService: TranslateService) {
  }

  public ngOnInit(): void {
    if (!this.controlContainer) {
      return;
    }

    let controlName = this.formControlName;
    if (this.utilsValidationMessage) {
      controlName = this.utilsValidationMessage;
    }
    this.control = this.controlContainer.control.get(controlName);
    if (this.control) {
      this.statusChangesSubscription = this.control.statusChanges.subscribe(() => this.onStatusChanged(this.control));
      this.validateFormSubscription = this.formValidationService.validateForm.subscribe(() => {
        this.control.markAsTouched();
        this.control.updateValueAndValidity();
      });
    }
  }

  public ngOnDestroy(): void {
    if (this.statusChangesSubscription) {
      this.statusChangesSubscription.unsubscribe();
    }
    if (this.validateFormSubscription) {
      this.validateFormSubscription.unsubscribe();
    }
  }

  private onStatusChanged(control: AbstractControl): void {
    let path = this.datevMessagePath;
    if (this.utilsValidationMessage) {
      path = this.utilsValidationMessage;
    }

    this.messageService.clearMessages(path);

    if ((control.pristine && control.untouched) || control.status === 'VALID' || control.disabled) {
      return;
    }

    const validationErrors = Object.keys(control.errors);
    validationErrors.forEach((key: string, index: number) => {
      const id = `${path}${index}`;
      let message = control.errors[key];
      if (key === 'bsDate') {
        message = this.translateService.instant('SHARED.VALIDATION.DATE_DEFAULT');
      }
      this.messageService.addErrorMessage(path, id, message);
    });
  }
}
